module.exports = __webpack_public_path__ + "f7795e27f3ea202f5fd762c525c9471d.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/eyes/googley-26.png
// module id = 2043
// module chunks = 0